import { Divider, Drawer } from '@reveni-io/reveni-ui'

import useTopicNotes from './hooks/useTopicNotes/useTopicNotes'
import SentimentFilters from './SentimentFilters/SentimentFilters'
import TopicDrawerBody from './TopicDrawerBody/TopicDrawerBody'
import TopicDrawerHeader from './TopicDrawerHeader/TopicDrawerHeader'
import TopicDrawerPaginator from './TopicDrawerPaginator/TopicDrawerPaginator'
import TopicDrawerSearch from './TopicDrawerSearch/TopicDrawerSearch'
import * as Styles from './styles'

const TopicDrawer = ({ show, selectedTopic, onClose, reasonId, storeId, filters }) => {
  const {
    data,
    loading,
    onChangeSearch,
    selectedSentimentFilter,
    onChangeSentimentFilter,
    page,
    setPage,
    pageSize,
    onChangePageSize,
    totalPages,
  } = useTopicNotes({
    reasonId,
    storeId,
    topicId: selectedTopic?.topic_id,
    filters,
  })

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <Styles.Container>
        <TopicDrawerHeader topic={selectedTopic} sentiments={data?.sentiments} />
        <Divider />
        <TopicDrawerSearch onSearch={onChangeSearch} />
        <SentimentFilters counts={data?.counts} selected={selectedSentimentFilter} onChange={onChangeSentimentFilter} />
        <TopicDrawerBody data={data} loading={loading} />
        <TopicDrawerPaginator
          show={!loading && data?.results?.length > 0}
          page={page}
          pageSize={pageSize}
          totalPages={totalPages}
          previous={data?.previous}
          next={data?.next}
          onChangePage={setPage}
          onChangePageSize={onChangePageSize}
        />
      </Styles.Container>
    </Drawer>
  )
}

export default TopicDrawer
